// ============================================================================
// EDIT DISTANCE - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'edit-distance',
  name: 'Edit Distance',
  category: 'Dynamic Programming',
  complexity: {
    time: 'O(MN)',
    space: 'O(min(M, N))'
  },
  description: 'A dynamic programming algorithm that computes the minimum number of operations (insertions, deletions, substitutions) required to transform one string into another. Also known as Levenshtein distance.'
};
